import { Component, Inject, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { OnDisplayService } from 'src/app/services/ondisplay/onDisplay.service';
import { from, Subject, Subscription, timer } from 'rxjs';
import * as dayjs from 'dayjs';
import { DataService } from 'src/app/core/services/data.service';
import { User } from 'src/app/core/models/user';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import Swal from 'sweetalert2';
import { Order } from 'src/app/core/models/client';
import { environment } from 'src/environments/environment';
import { getFirebaseBackend } from 'src/app/authUtils';
import { UserService } from 'src/app/services/user/user.service';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-on-display',
	templateUrl: './on-display.component.html',
	styleUrls: ['./on-display.component.scss'],
})
export class OnDisplayComponent implements OnInit, OnDestroy {
	@Input() campaign_id: number;
	@Input() last_click: number;
	@Input() order: Order;
	@Output() close_campaign: EventEmitter<any>;
	@Output() order_time_supplied: EventEmitter<boolean>;
	public timerSubscription: Subscription;
	public user: User = null;
	public timeInMinutes = 5;
	public timeInMiliSeconds: number;
	private destroy$ = new Subject<void>();

	constructor(
		public utils: UtilsService,
		public authenticationService: AuthenticationService,
		public onDisplayService: OnDisplayService,
		public dataService: DataService,
		private userSrv: UserService,
	) {
		this.close_campaign = new EventEmitter();
		this.order_time_supplied = new EventEmitter();
		this.timeInMiliSeconds = this.timeInMinutes * 60 * 1000;
	}

	ngOnInit(): void {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		this.timerSubscription?.unsubscribe();
	}

	isThereCampaignTimer() {
		this.onDisplayService
			.isThereCampaignTimer(this.user.IdUser, Date.now(), dayjs().format('YYYY-MM-DD'), this.campaign_id)
			.then(() => this.startTimer())
			.catch((err) => console.error('Timer check failed:', err));
	}

	refreshProspect(prospect: any) {
		this.last_click = Date.now();
		this.saveTime();
		this.isThereCampaignTimer();
	}

	startTimer() {
		this.timerSubscription = timer(this.timeInMiliSeconds).subscribe((res) => {
			this.userSrv.getRingCentralCalls({ extId: this.user.rc_ext_id }).subscribe((data: any) => {
				const now = dayjs();
				let lastCallComparision = false;
				const lastClick = dayjs(this.last_click);
				if (data.success !== 'User in Call') {
					if (data.success.length > 0) {
						const lastCall = dayjs(data.success[0].startTime);
						lastCallComparision = now.diff(lastCall) >= this.timeInMiliSeconds;
					} else {
						lastCallComparision = true;
					}

					if (lastCallComparision || now.diff(lastClick) >= this.timeInMiliSeconds) {
						this.saveTime();
						Swal.fire({
							title: 'Inactive',
							icon: 'info',
							text: "It's been a while since your last call, do you want close this campaign?",
							showCancelButton: true,
							confirmButtonText: 'Continue',
							cancelButtonText: 'Close Campaign',
							allowOutsideClick: false,
							allowEscapeKey: false,
							allowEnterKey: false,
						}).then((result) => {
							if (result.value) {
								this.updateStartTime();
							} else {
								this.timerSubscription.unsubscribe();
								this.close_campaign.emit('close');
							}
						});
					} else {
						this.saveTime();
						this.resetTimer();
					}
				} else {
					this.saveTime();
					this.resetTimer();
				}
			});
		});
	}

	resetTimer() {
		this.timerSubscription.unsubscribe();
		this.startTimer();
	}

	saveTime() {
		const payload = {
			user_id: this.user.IdUser,
			new_timestamp: new Date().getTime(),
			date: dayjs().format('YYYY-MM-DD'),
			campaign_id: this.campaign_id,
		};
		this.onDisplayService.saveUserTime(payload);
	}

	updateStartTime() {
		this.onDisplayService.updateStartTime(this.user.IdUser, new Date().getTime(), dayjs().format('YYYY-MM-DD'), this.campaign_id).then((data) => {
			this.resetTimer();
		});
	}

	// getTimeSupplied(){
	//     this.onDisplayService.getTimeSupplied(this.campaing_id, dayjs(this.order.start_date).format('YYYY-MM-DD')).then(data=>{
	//         const order_time_secs = this.order.total_hours * 60 * 60;
	//         if(order_time_secs < data.time_supplied){
	//             this.order_time_supplied.emit(true);
	//         }
	//     })
	// }
}
